module.exports = __webpack_public_path__ + "img/3-4.0b0e1d5f.png";